<template>
  <label class="custom-checkbox">
    <input type="checkbox" :checked="isChecked" @change="toggleCheck" />
    <span class="checkmark"></span>
    <slot />
  </label>
</template>

<script>
export default {
  name: "CustomCheckbox",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked() {
      return this.value;
    }
  },
  methods: {
    toggleCheck(event) {
      this.$emit("input", event.target.checked);
    }
  }
};
</script>

<style scoped>
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
}

/* Hide the default checkbox, but keep it in the DOM for accessibility */
.custom-checkbox input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox appearance */
.custom-checkbox .checkmark {
  width: 16px;
  height: 16px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-right: 10px;
  display: inline-block;
  position: relative;
}

/* Checkmark (hidden by default) */
.custom-checkbox .checkmark::after {
  content: "";
  position: absolute;
  display: none;
  left: 4px;
  top: 0;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Show checkmark when checked */
.custom-checkbox input[type="checkbox"]:checked + .checkmark::after {
  display: block;
}

/* Change the border and background when checked */
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #2e48da;
  border-color: #2e48da;
}
</style>



// WEBPACK FOOTER //
// src/components/resuables/custom-checkbox.vue